// Prod API
// export const apiUrl = "https://icefall.tricer.tractebel-engie.com/";
// export const pdfUrl = "https://genpdf.tricer.tractebel-engie.com/";
// No Prod API
export const apiUrl = "https://icefall.tricer-noprod.aws.tractebel-engie.com/";
export const pdfUrl = "https://genpdf.tricer-noprod.aws.tractebel-engie.com/";
// Demo API
// export const apiUrl = "https://1c6gtt22c1.execute-api.eu-west-1.amazonaws.com/demo/";

export const mapbox_access_token =
  "pk.eyJ1Ijoib2xhdXphbm5lIiwiYSI6ImNreDFvZ2FnYjFpYWUyb3VyY2hscmk3cmwifQ.NgvjPTC3bkrlNvtgPjERLw";
